import Vue from 'vue';
import Vuex from 'vuex';
import AuthStore from './modules/auth.store';
import UserStore from './modules/user.store';
import CartStore from './modules/cart.store';
import VuexPersistence from 'vuex-persist';
import { I18nStore } from '@/store/modules/i18n.store';

Vue.use(Vuex);

// const vuexLocal = new VuexPersistence({
//   storage: window.localStorage
// });

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state: any) => ({
    id: state.id,
    user: state.user,
  }),
});

export default new Vuex.Store<{ version: string; layout: string; auth?: any; user?: any }>({
  state: {
    version: '0.1',
    layout: 'div',
  },
  mutations: {
    SET_LAYOUT(state, layout) {
      state.layout = layout;
    },
  },
  actions: {},
  modules: {
    auth: AuthStore,
    user: UserStore,
    cart: CartStore,
    i18n: I18nStore,
  },
  plugins: [vuexLocal.plugin],
});
